export default __webpack_public_path__ + "static/media/R2L truck.c5f74778.svg";